import {useEffect} from 'react';
import {useSearchParams} from 'react-router';
import useSourcesFileViewerStore from '../../../stores/useSourcesFileViewerStore';

export function useInitSourcesFileViewer() {
    const [searchParams] = useSearchParams();
    const initFromUrl = useSourcesFileViewerStore((s) => s.initFromUrl);
    const initialized = useSourcesFileViewerStore((s) => s._initialized);

    useEffect(() => {
        if (!initialized) {
            initFromUrl(searchParams);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized, initFromUrl]);
}

